import { ActivatedRouteSnapshot, CanActivateFn, GuardResult, MaybeAsync, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '@core/services/user.service';
import { map, tap } from 'rxjs';
import { User } from '@core/models/user';

export function rsNumberSelectionGuard(): CanActivateFn {
  let isFirstAccess = true;
  return (route: ActivatedRouteSnapshot): MaybeAsync<GuardResult> => {
    const userService = inject(UserService);
    const router = inject(Router);
    const rsUserNumberParam = route.queryParams.rsUserNumber as string;
    const currentUser = userService.getCurrentUser();
    const users$ = userService.getAvailableUsers();

    return users$.pipe(
      map(users => {
        if (shouldSelectUniqueUser(isFirstAccess, users) || shouldSelectSearchParamUser(rsUserNumberParam, currentUser)) {
          return router.parseUrl(userService.getDefaultRedirectURL());
        } else {
          return true;
        }
      }),
      tap(() => isFirstAccess = false),
    );
  };
}

function shouldSelectUniqueUser(isFirstAccess: boolean, users: User[]) {
  return isFirstAccess && users.length === 1;
}

function shouldSelectSearchParamUser(rsUserNumberParam: string, currentUser: User | null) {
  return rsUserNumberParam && currentUser?.loginString === rsUserNumberParam;
}
